import { FixedSide, GetWallets } from 'shared/data/wallets/v1';
import z from 'zod';

import { ConversionData } from '../../ConvertCurrencyPopup.types';
import { schema } from './ConvertCurrencyPopupContent.schema';

export const filterAvailableCurrencies = (wallet: GetWallets['response']['items'][number]) => {
    return wallet.isVisible && wallet.isConvertible;
};

export const conversionDataToFormValues = (conversionData: ConversionData): z.infer<typeof schema> => {
    const { fromCurrency, toCurrency, amount, fixedSide } = conversionData;

    return {
        fromCurrency,
        toCurrency,
        fromAmount: fixedSide === FixedSide.sell ? amount : null,
        toAmount: fixedSide === FixedSide.buy ? amount : null,
        fixedSide,
    };
};
